export interface AlainMockConfig {
  /**
   * è§åå®ä¹æ°æ®
   */
  data: any;
  /**
   * è¯·æ±å»¶è¿ï¼åä½ï¼æ¯«ç§ï¼é»è®¤ï¼`300`
   */
  delay?: number;
  /**
   * æ¯å¦å¼ºå¶ææè¯·æ±é½Mockï¼é»è®¤ï¼`false`ï¼`true` è¡¨ç¤ºå½è¯·æ±çURLä¸å­å¨æ¶ç´æ¥è¿å 404 éè¯¯ï¼`false` è¡¨ç¤ºæªå½ä¸­æ¶åéçå®HTTPè¯·æ±
   */
  force?: boolean;
  /**
   * æ¯å¦æå° Mock è¯·æ±ä¿¡æ¯ï¼å¼¥è¡¥æµè§å¨æ Networkä¿¡æ¯ï¼é»è®¤ï¼`true`
   */
  log?: boolean;
  /**
   * æ¯å¦æ¦æªå½ä¸­åç»§ç»­è°ç¨åç»­æ¦æªå¨ç `intercept` æ¹æ³ï¼é»è®¤ï¼`true`
   */
  executeOtherInterceptors?: boolean;
}
